import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getPlanTemplate = (callback) => {
  return async (dispatch) => {
    dispatch({ type: 'GET_PLAN_TEMPLATES' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/plans/template`, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'GET_PLAN_TEMPLATES_DONE',
              payload: {
                planTemplates: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GET_PLAN_TEMPLATES_FAILED',
              payload: `Failed to fetch plan templates`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GET_PLAN_TEMPLATES_FAILED',
            payload: `Failed to fetch plan templates`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GET_PLAN_TEMPLATES_FAILED',
        payload: `Failed to fetch plan templates`,
      });
    }
  };
};

export default getPlanTemplate;
